import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Cookie } from "lucide-react";

const KEY = "bb_cookie_consent";

export default function CookieBanner() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(KEY)) {
      const t = setTimeout(() => setShow(true), 2600);
      return () => clearTimeout(t);
    }
  }, []);

  const choose = (accepted) => {
    localStorage.setItem(KEY, accepted ? "accepted" : "dismissed");
    setShow(false);
  };

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          data-testid="cookie-banner"
          role="region"
          aria-label="Cookie consent"
          data-lenis-prevent
          initial={{ y: 40, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 40, opacity: 0 }}
          transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
          className="glass-strong fixed inset-x-3 bottom-[calc(5.25rem+env(safe-area-inset-bottom))] z-50 mx-auto max-h-[calc(100dvh-7rem)] max-w-xl overflow-y-auto overscroll-contain rounded-2xl p-4 shadow-2xl shadow-black/60 sm:inset-x-6 sm:p-5 md:bottom-6"
        >
          <div className="flex items-start gap-3 sm:gap-4">
            <span className="hidden h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-brand/15 text-brand min-[400px]:flex">
              <Cookie size={18} />
            </span>
            <div className="min-w-0 flex-1">
              <p className="text-xs leading-relaxed text-slate-300 sm:text-sm" data-testid="cookie-banner-text">
                We use minimal cookies for basic analytics to improve your experience. Your enquiry
                details always stay private.{" "}
                <a
                  href="/privacy-policy.html"
                  data-testid="cookie-privacy-link"
                  className="text-brand underline-offset-2 hover:underline"
                >
                  Privacy Policy
                </a>
              </p>
              <div className="mt-3.5 flex flex-wrap gap-2.5">
                <button
                  data-testid="cookie-accept-btn"
                  onClick={() => choose(true)}
                  className="min-w-[6.5rem] flex-1 rounded-full bg-brand px-5 py-2.5 text-xs font-bold text-white transition-colors duration-300 hover:bg-brand-hover min-[400px]:flex-none"
                >
                  Accept
                </button>
                <button
                  data-testid="cookie-dismiss-btn"
                  onClick={() => choose(false)}
                  className="min-w-[6.5rem] flex-1 rounded-full border border-slate-600 px-5 py-2.5 text-xs font-semibold text-slate-300 transition-colors duration-300 hover:border-slate-400 hover:text-white min-[400px]:flex-none"
                >
                  Dismiss
                </button>
              </div>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
